import React from 'react';

const isPDFEnabled = navigator?.pdfViewerEnabled;
const IMAGE_EXTENSIONS = ['.png', '.jpeg', '.jpg'];

const FileViewer = ({ url, fileExt }) => {
  // We just use an img tag if the file is an image.
  if (IMAGE_EXTENSIONS.includes(fileExt)) {
    return (
      <div className="page-content img-viewer">
        <img src={url} />
      </div>
    );
  }

  // We check the browser if it is able to render pdfs natively.
  if (fileExt === '.pdf' && isPDFEnabled) {
    return (
      <div className="page-content pdf-viewer">
        <object
          type="application/pdf"
          data={url}
          width="500px"
          height="800px"
        >
          <iframe
            src={
              `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`
            }
            title="Note file viewer"
          />
        </object>
      </div>
    );
  }

  // If not a pdf or browser does not have capability to render pdf, then use fallback of
  // google drive viewer, which can be unreliable.
  return (
    <div className="page-content google-viewer">
      <iframe
        src={
          `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`
        }
        title="Note file viewer"
      />
    </div>
  );
};

export default FileViewer;
